import type { TFunction } from 'i18next';
import { z } from 'zod';

import type { Dayjs } from '@/js/libs/dayjs';

export const createSchema = (t: TFunction) =>
  z
    .object({
      month: z
        .custom<Dayjs>()
        .nullable()
        .refine(Boolean, { message: t('messages:FIELD_IS_REQUIRED') }),
      deadline: z
        .custom<Dayjs>()
        .nullable()
        .refine(Boolean, { message: t('messages:FIELD_IS_REQUIRED') }),
    })
    .superRefine((data, ctx) => {
      if (!data.month || !data.deadline) return;
      const firstDayOfSelectedMonth = data.month.startOf('month');
      if (data.deadline.isBefore(firstDayOfSelectedMonth)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: t('messages:DEADLINE_CANNOT_BE_BEFORE_SELECTED_MONTH'),
          path: ['deadline'],
        });
      }
    });
